<template>
  <b-modal
    ref="dashboardsAccessModal"
    hide-footer
    centered
    :title="`Dashboards Access for ${email || uid}`"
  >
    <div v-if="uid && dashboards">
      <b-table
        striped
        hover
        :items="items"
        :fields="fields"
      >
        <template slot="hasAccess" slot-scope="row">
          <b-form-checkbox
            :checked="row.item.hasAccess"
            @change="removeDashboardAccess($event, row.item.dId)"
            :disabled="!row.item.hasAccess || isOwner(row.item.owner)"
          >
            <span v-if="isOwner(row.item.owner)">is owner</span>
          </b-form-checkbox>
        </template>

        <template slot="edit" slot-scope="row">
          <b-button size="sm" @click="row.toggleDetails" class="mr-2">
            <span v-if="row.detailsShowing">
              <icon name="long-arrow-up" />
              <span>Hide</span>
            </span>
            <span v-else>
              <icon name="long-arrow-down" />
              <span>Show</span>
            </span>
          </b-button>
        </template>

        <template slot="row-details" slot-scope="row">
          <b-form
            :id="`d-edit-${row.item.dId}`"
            @submit.prevent="saveDashboardAccess(`d-edit-${row.item.dId}`, row.index)"
          >
            <b-form-group label="Role:">
              <b-form-select
                :options="roleOptions"
                class="js-role"
                :value="getRoleVal(row.item) || 'read'"
              ></b-form-select>
            </b-form-group>
            <div v-if="row.item.isNFLDash">
              <hr>
              <h5>Profile Info</h5>
              <b-form-group label="Name:">
                <b-form-input
                  :value="getProfileInfoVal('name')"
                  class="js-profile-info-name"
                />
              </b-form-group>
              <b-form-group label="Team:">
                <b-form-input
                  :value="getProfileInfoVal('team')"
                  class="js-profile-info-team"
                />
              </b-form-group>
              <b-form-group label="Website ID:">
                <b-form-input
                  :value="getProfileInfoVal('website-id')"
                  class="js-profile-info-website-id"
                />
              </b-form-group>
            </div>
            <b-button
              variant="primary"
              size="sm"
              type="submit"
            >
              Save
            </b-button>
          </b-form>
        </template>
      </b-table>
    </div>
  </b-modal>
</template>

<script>
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'

let $ = window.$

export default {
  props: ['dashboards', 'access', 'profilesInfo'],
  data () {
    return {
      uid: null,
      email: null,
      fields: [
        { key: 'dName', label: 'Dashboard Name' },
        { key: 'hasAccess', label: 'Has Access' },
        'edit'
      ],
      roleOptions: [
        { value: 'read', text: 'Regular' },
        { value: 'update', text: 'Moderator' }
      ]
    }
  },
  computed: {
    items () {
      const items = []

      for (let dId in this.dashboards) {
        const dashboard = this.dashboards[dId]
        let hasAccess = false

        if (dashboard.sharedWith && dashboard.sharedWith[this.uid]) {
          hasAccess = true
        }
        if (dashboard.owner === this.uid) hasAccess = true

        items.push({
          dId,
          owner: dashboard.owner,
          dName: dashboard.name,
          hasAccess,
          isNFLDash: dashboard.isNFLDash
        })
      }

      return items
    }
  },
  methods: {
    closeModal () {
      if (this.$refs['dashboardsAccessModal']) {
        this.$refs['dashboardsAccessModal'].hide()
      }
    },
    saveDashboardAccess (refKey, idx) {
      const form = $(`#${refKey}`)[0]
      const row = this.items[idx]
      const role = $(form).find('.js-role').val()

      const vm = this
      const data = {
        uid: vm.uid,
        dId: row.dId,
        role
      }

      if (row.isNFLDash) {
        const profileInfo = {
          name: $(form).find('.js-profile-info-name').val() || null,
          teamName: $(form).find('.js-profile-info-team').val() || null,
          websiteId: $(form).find('.js-profile-info-website-id').val() || null
        }

        data.profileInfo = profileInfo
      }

      eventBus.$emit('saveDashboardAccess', data)
    },
    removeDashboardAccess (val, dId) {
      const vm = this
      const data = {
        uid: vm.uid,
        dId
      }

      if (!val) eventBus.$emit('removeDashboardAccess', data)
    },
    isOwner (ownerId) {
      return (ownerId === this.uid) ? true : false
    },
    getRoleVal (item) {
      if (
        this.access.Dashboard[this.uid] &&
        this.access.Dashboard[this.uid][item.dId]
      ) {
        return Object.keys(this.access.Dashboard[this.uid][item.dId])[0]
      }
      return null
    },
    getProfileInfoVal (type) {
      if (!this.profilesInfo[this.uid]) return ''

      switch (type) {
        case 'name':
          return this.profilesInfo[this.uid].name
          break
        case 'team':
          return this.profilesInfo[this.uid].teamName
          break
        case 'website-id':
          return this.profilesInfo[this.uid].websiteId
          break
      }
    }
  },
  created () {
    eventBus.$on('showDashboardsAccessModal', (data) => {
      this.uid = data.uid
      this.email = data.email

      if (this.$refs['dashboardsAccessModal']) {
        this.$refs['dashboardsAccessModal'].show()
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ControlPanel/modals/DashboardsAccess.vue